import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon, TruckIcon, HeadphonesIcon, AwardIcon, UsersIcon, TargetIcon } from 'lucide-react';
import { Button } from '../components/ui/Button';
export function AboutPage() {
  return <div className="min-h-screen bg-white" data-id="element-825">
      {/* Hero */}
      <div className="bg-gradient-to-r from-primary-600 to-primary-800 py-20" data-id="element-826">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-827">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-828">
            About Gadgets Zone
          </h1>
          <p className="text-xl text-primary-100 max-w-2xl mx-auto" data-id="element-829">
            Your trusted destination for affordable gadgets and electronics in
            Pakistan
          </p>
        </div>
      </div>

      {/* Story section */}
      <div className="max-w-7xl mx-auto px-4 py-16" data-id="element-830">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-831">
          <div data-id="element-832">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-833">Our Story</h2>
            <div className="space-y-4 text-gray-600" data-id="element-834">
              <p data-id="element-835">
                Founded in 2020, Gadgets Zone started with a simple mission: to
                make quality technology accessible to everyone in Pakistan. We
                believe that great gadgets shouldn't come with a premium price
                tag.
              </p>
              <p data-id="element-836">
                What began as a small online store has grown into one of
                Pakistan's most trusted destinations for electronics and
                gadgets. We've served over 50,000 happy customers across the
                country.
              </p>
              <p data-id="element-837">
                Our team is passionate about technology and dedicated to
                providing exceptional customer service. We carefully curate our
                product selection to ensure you get only the best quality items
                at competitive prices.
              </p>
            </div>
            <Link to="/products" className="inline-block mt-6" data-id="element-838">
              <Button variant="primary" size="lg" data-id="element-839">
                Explore Our Products
              </Button>
            </Link>
          </div>
          <div className="relative" data-id="element-840">
            <div className="aspect-square bg-gradient-to-br from-primary-100 to-primary-200 rounded-2xl flex items-center justify-center" data-id="element-841">
              <div className="text-center" data-id="element-842">
                <img src="https://cdn.magicpatterns.com/uploads/fRsBpVfPoCHsQawYgHjccg/ChatGPT_Image_Mar_6,_2026,_03_48_02_AM.png" alt="Gadgets Zone" className="h-32 w-auto object-contain mx-auto mb-4 bg-white rounded-2xl p-2" data-id="element-843" />
                <p className="text-2xl font-bold text-primary-600" data-id="element-844">
                  Gadgets Zone
                </p>
                <p className="text-primary-500" data-id="element-845">Since 2020</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Values */}
      <div className="bg-gray-50 py-16" data-id="element-846">
        <div className="max-w-7xl mx-auto px-4" data-id="element-847">
          <div className="text-center mb-12" data-id="element-848">
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-849">
              Why Choose Us
            </h2>
            <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-850">
              We're committed to providing the best shopping experience for our
              customers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-851">
            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-852">
              <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center mb-4" data-id="element-853">
                <ShieldCheckIcon className="w-7 h-7 text-green-600" data-id="element-854" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-855">
                100% Genuine Products
              </h3>
              <p className="text-gray-600" data-id="element-856">
                Every product we sell is authentic and sourced directly from
                authorized distributors.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-857">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4" data-id="element-858">
                <TruckIcon className="w-7 h-7 text-blue-600" data-id="element-859" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-860">
                Fast Nationwide Delivery
              </h3>
              <p className="text-gray-600" data-id="element-861">
                We deliver to all major cities in Pakistan with free shipping on
                orders over PKR 5,000.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-862">
              <div className="w-14 h-14 bg-primary-100 rounded-xl flex items-center justify-center mb-4" data-id="element-863">
                <HeadphonesIcon className="w-7 h-7 text-primary-600" data-id="element-864" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-865">
                24/7 Customer Support
              </h3>
              <p className="text-gray-600" data-id="element-866">
                Our dedicated support team is always ready to help you with any
                questions or concerns.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-867">
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4" data-id="element-868">
                <AwardIcon className="w-7 h-7 text-purple-600" data-id="element-869" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-870">
                Best Price Guarantee
              </h3>
              <p className="text-gray-600" data-id="element-871">
                We offer competitive prices and price matching to ensure you get
                the best deals.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-872">
              <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-4" data-id="element-873">
                <UsersIcon className="w-7 h-7 text-red-600" data-id="element-874" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-875">
                50,000+ Happy Customers
              </h3>
              <p className="text-gray-600" data-id="element-876">
                Join thousands of satisfied customers who trust Gadgets Zone for
                their tech needs.
              </p>
            </div>

            <div className="bg-white p-6 rounded-xl shadow-card" data-id="element-877">
              <div className="w-14 h-14 bg-teal-100 rounded-xl flex items-center justify-center mb-4" data-id="element-878">
                <TargetIcon className="w-7 h-7 text-teal-600" data-id="element-879" />
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2" data-id="element-880">
                Easy Returns
              </h3>
              <p className="text-gray-600" data-id="element-881">
                Not satisfied? Return within 7 days for a full refund. No
                questions asked.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div className="py-16" data-id="element-882">
        <div className="max-w-7xl mx-auto px-4" data-id="element-883">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-884">
            <div data-id="element-885">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-886">
                50K+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-887">Happy Customers</p>
            </div>
            <div data-id="element-888">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-889">
                1000+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-890">Products</p>
            </div>
            <div data-id="element-891">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-892">
                50+
              </p>
              <p className="text-gray-600 mt-2" data-id="element-893">Brands</p>
            </div>
            <div data-id="element-894">
              <p className="text-4xl md:text-5xl font-bold text-primary-600" data-id="element-895">
                4.8
              </p>
              <p className="text-gray-600 mt-2" data-id="element-896">Average Rating</p>
            </div>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="bg-primary-600 py-16" data-id="element-897">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-898">
          <h2 className="text-3xl font-bold text-white mb-4" data-id="element-899">Ready to Shop?</h2>
          <p className="text-primary-100 mb-8 max-w-2xl mx-auto" data-id="element-900">
            Explore our wide range of gadgets and electronics. Find the perfect
            tech for your lifestyle.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-901">
            <Link to="/products" data-id="element-902">
              <Button variant="secondary" size="lg" data-id="element-903">
                Browse Products
              </Button>
            </Link>
            <Link to="/contact" data-id="element-904">
              <Button variant="outline" size="lg" className="border-white text-white hover:bg-white/10" data-id="element-905">
                Contact Us
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>;
}